module.exports = __webpack_public_path__ + "img/marker_normal_focused.af566142.svg";